import { render, staticRenderFns } from "./PromotionStartDate.vue?vue&type=template&id=77648e1a&"
import script from "./PromotionStartDate.vue?vue&type=script&lang=ts&"
export * from "./PromotionStartDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports